import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviceCard from './DeviceCard';

import { get_image } from '../utils/imageUtils';
import { useDeviceData } from '../context/DeviceDataContext';

function DeviceCardWrapper({ client, deviceID, deviceType, addDevicePosition, focusDevice, focusedDevice }) {
    const { t } = useTranslation();
    const { devicesData, loading } = useDeviceData();
    const [deviceStatus, setDeviceStatus] = React.useState(null);

    const fetchStatus = React.useCallback(async () => {
        if (!deviceID) return;
        const { getClientStatus } = await import('../utils/clientUtils');
        const status = await getClientStatus(deviceID);
        setDeviceStatus(status);
        if (status && Number.isFinite(status.lat) && Number.isFinite(status.lon)) {
            addDevicePosition(deviceID, { lat: status.lat, lng: status.lon });
        }
    }, [deviceID, addDevicePosition]);

    React.useEffect(() => {
        fetchStatus();

        const interval = setInterval(() => {
            if (document.visibilityState === 'visible') {
                fetchStatus();
            }
        }, 60000);

        return () => clearInterval(interval);
    }, [fetchStatus]);

    const refreshStatus = React.useCallback(() => {
        setTimeout(fetchStatus, 2000);
    }, [fetchStatus]);


    // Always define device, even if null
    const device = (devicesData && devicesData.devices && Array.isArray(devicesData.devices.types))
        ? devicesData.devices.types.find(device => device.dtid === deviceType)
        : null;

    const [backgroundImage, setBackgroundImage] = React.useState(null);
    React.useEffect(() => {
        if (!device) return;
        async function fetchImage() {
            const data = await get_image(device.imageurl);
            if (data && data.body) {
                const blob = await data.body.blob();
                setBackgroundImage(URL.createObjectURL(blob));
            }
        }
        fetchImage();
    }, [device]);

    const [offlineImage, setOfflineImage] = React.useState(null);
    React.useEffect(() => {
        if (!device) return;
        async function fetchImage() {
            const data = await get_image(device.imageurloffline);
            if (data && data.body) {
                const blob = await data.body.blob();
                setOfflineImage(URL.createObjectURL(blob));
            }
        }
        fetchImage();
    }, [device]);

    if (loading) return <div>{t('deviceCardWrapper.loading')}</div>;
    if (!devicesData || !devicesData.devices || !Array.isArray(devicesData.devices.types)) return <div>{t('deviceCardWrapper.noDeviceData')}</div>;

    return (
        <DeviceCard
            client={client}
            device={device}
            deviceID={deviceID}
            deviceStatus={deviceStatus}
            backgroundImage={backgroundImage}
            offlineImage={offlineImage}
            focusDevice={focusDevice}
            focusedDevice={focusedDevice}
            refreshStatus={refreshStatus}
        />
    );
}

export default DeviceCardWrapper;